import MoneyDisplay from 'components/util/MoneyDisplay';
import { ComponentProps } from 'react';
import { cn } from 'utils/cn';

/** The grey tile. Props and ref land on its `div`, so a tooltip can use it as its trigger. */
export const GreyBoxes = ({ className, ...props }: ComponentProps<'div'>) => (
    <div
        {...props}
        className={cn(
            'bg-grey-50 relative flex w-full flex-col rounded-md p-3 text-nowrap wrap-break-word hyphens-auto',
            className
        )}
    />
);

interface Props {
    title: string;
    value: number | string | undefined;
    currency?: string;
    className?: string;
}

const GreyBox = ({ title, value, currency, className }: Props) => (
    <GreyBoxes className={className}>
        <div className="text-fg-secondary text-[12px]">{title}</div>
        <div className="text-[14px] font-semibold whitespace-nowrap">
            {currency !== undefined && typeof value === 'number' ? (
                <MoneyDisplay amount={value} currency={currency} />
            ) : (
                <p className="text-body1 text-fg flex items-center font-semibold">{value || '-'}</p>
            )}
        </div>
    </GreyBoxes>
);

export default GreyBox;
